// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-accordionpreviewimage_default__2h6ss"};